import theme from "../themes/smerth/";

export default theme;
